import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

// import './passwordmask.css';

class PasswordMask extends Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
    };
  }

  componentDidMount() {
    this.handlePasswordHide();
  }

  handlePasswordShow = () => {
    const { password } = this.props;
    this.setState({text: password});
  }

  handlePasswordHide = () => {
    const { password } = this.props;
    this.setState({text: '*'.repeat(password.length)});
  }

  render() {
    const { text } = this.state;
    
    return (
      <p
        style={{minWidth: '80px', margin: 0}}
        onMouseEnter={() => this.handlePasswordShow()}
        onMouseLeave={() => this.handlePasswordHide()}
      >
        {text}
      </p>
    )
  }

}


const mapStateToProps = state => ({

});

const mapDispatchToProps = dispatch =>
bindActionCreators(
  {
  },
  dispatch
);

export default connect(mapStateToProps, mapDispatchToProps)(PasswordMask);
